// Google Analytics 4. The tag itself is added to <head> by gatsby-ssr.js in
// production builds only; here, events are sent if the tag is present and
// silently dropped otherwise (development, blockers, no consent scripts).
export const GA_ID = 'G-2Q5H0M0CL8'

export function track(name, params) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  try {
    window.gtag('event', name, params)
  } catch (e) { /* analytics must never break the page */ }
}
